import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import MainLayout from "../../components/MainLayout";
import Loading from "../../components/Loading";
import HelmetCustom from "../../components/HelmetCustom";
import api from "../../services/api";
import {
  Container,
  Content,
  EmptyMessage,
  Layout,
  Sidebar,
  SidebarLink,
  SidebarNav,
  SidebarTitle,
} from "./styles";

export default function EmpresaPagina({ history, match }) {
  const { slug } = match.params;
  const [pagina, setPagina] = useState(null);
  const [tipo, setTipo] = useState(null);
  const [sidebar, setSidebar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function fetchPagina() {
      setLoading(true);
      setError(null);

      try {
        const { data } = await api.get(
          `/identidade-visual/paginas/${encodeURIComponent(slug)}`
        );

        if (!isMounted) return;

        setPagina(data);
        setTipo(data.tipo);
        setSidebar(data.sidebar || []);
      } catch (err) {
        if (!isMounted) return;

        const notFound = err?.response?.status === 404;

        setPagina(null);
        setTipo(null);
        setSidebar([]);
        setError(
          notFound
            ? "Página não encontrada"
            : "Não foi possível carregar esta página"
        );
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    fetchPagina();

    return () => {
      isMounted = false;
    };
  }, [slug]);

  const showSidebar = !loading && !error && sidebar.length > 1;
  const pageTitle = pagina?.seo?.titulo || pagina?.titulo;
  const seoTitle = error
    ? (error === "Página não encontrada" ? "Página não encontrada" : "Página")
    : (pagina?.seo?.titulo || pagina?.titulo || "Página");

  return (
    <MainLayout history={history}>
      <HelmetCustom
        pageTitle={seoTitle}
        content={pagina?.seo?.meta_description}
        fbImage={pagina?.seo?.imagem_og}
        noindex={!!error}
      />
      <Container>
        {loading ? (
          <Loading />
        ) : error ? (
          <EmptyMessage>{error}</EmptyMessage>
        ) : (
          <Layout>
            <Content>
              {pageTitle && <h1>{pageTitle}</h1>}
              {ReactHtmlParser(pagina?.conteudo || "")}
            </Content>

            {showSidebar && (
              <Sidebar>
                <SidebarTitle>Informações Legais</SidebarTitle>

                <SidebarNav>
                  {sidebar.map((item) => (
                    <SidebarLink
                      as={Link}
                      className={item.atual ? "active" : ""}
                      key={item.slug}
                      to={`/p/${item.slug}`}
                    >
                      {item.titulo}
                    </SidebarLink>
                  ))}
                </SidebarNav>
              </Sidebar>
            )}
          </Layout>
        )}
      </Container>
    </MainLayout>
  );
}
